import React from 'react'
import classnames from 'classnames'

const PaperChecklistSVG = ({ className }) => {
  return (
    <svg
      viewBox="0 0 28 32"
      className={classnames('dealmed-icon', className)}
      aria-hidden={true}
      focusable={false}
    >
      <path d="M7 27h2c1.106 0 2-0.9 2-2v-2c0-1.1-0.894-2-2-2h-2c-1.106 0-2 0.9-2 2v2c0 1.1 0.894 2 2 2zM7 23h2v2h-2v-2zM7 11h2c1.106 0 2-0.9 2-2v-2c0-1.1-0.894-2-2-2h-2c-1.106 0-2 0.9-2 2v2c0 1.1 0.894 2 2 2zM7 7h2v2h-2v-2zM26 0h-24c-1.106 0-2 0.9-2 2v28c0 1.1 0.894 2 2 2h24c1.106 0 2-0.9 2-2v-28c0-1.1-0.894-2-2-2zM26 30h-24v-28h24v28zM13.5 9h8c0.275 0 0.5-0.225 0.5-0.5v-1c0-0.275-0.225-0.5-0.5-0.5h-8c-0.275 0-0.5 0.225-0.5 0.5v1c0 0.275 0.225 0.5 0.5 0.5zM13.5 17h8c0.275 0 0.5-0.225 0.5-0.5v-1c0-0.275-0.225-0.5-0.5-0.5h-8c-0.275 0-0.5 0.225-0.5 0.5v1c0 0.275 0.225 0.5 0.5 0.5zM13.5 25h8c0.275 0 0.5-0.225 0.5-0.5v-1c0-0.275-0.225-0.5-0.5-0.5h-8c-0.275 0-0.5 0.225-0.5 0.5v1c0 0.275 0.225 0.5 0.5 0.5zM7.412 17.9c0.131 0.131 0.344 0.131 0.475 0l4.013-3.975c0.131-0.131 0.131-0.344 0-0.475l-0.788-0.794c-0.131-0.131-0.344-0.131-0.475 0l-2.975 2.95-1.287-1.306c-0.131-0.131-0.344-0.131-0.475 0l-0.794 0.788c-0.131 0.131-0.131 0.344 0 0.475l2.306 2.338z"></path>
    </svg>
  )
}

export default PaperChecklistSVG
